
import { Component, Mixins } from "vue-property-decorator";
import { INamePropertyEditable, instanceOfINamePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class NamePropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: INamePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: INamePropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isNameEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfINamePropertyEditable(s) && s.name().isEditable(), false);
  }

  get name(): string {
    return this.readPropertyOrDefault(s => s.name().getValue(), "");
  }

  set name(value: string) {
    this.writePropertyWhenValid(s => s.name().setValue(value));
  }
}
